import { callApi } from 'utils/api';

/**
 * @return {Promise<config>}
 */
export const fetchHomeConfigApi = () => callApi('home/config');
